export const OrderAlertKinds = {
  OrderAmountWarning: 'orderAmountWarning',
  DeliveryDateWarning: 'deliveryDateWarning',
  DeliveryDateInfo: 'deliveryDateInfo',
  DeliveryDateConfirmedInfo: 'deliveryDateConfirmedInfo',
} as const;

/**
 * 発注ページのアラートのステータスタイプ
 */
export type OrderAlertKinds = (typeof OrderAlertKinds)[keyof typeof OrderAlertKinds];
